var map = {
	"./buck/index.js": 3810,
	"./cat/index.js": 3815,
	"./frankie/index.js": 3820,
	"./ollie/index.js": 3825,
	"./ollieStandard/index.js": 3830,
	"./robotboy/index.js": 3835,
	"./robotgirl/index.js": 3840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3809;